import { z } from 'zod';
import { atonePaymentSchema } from '@schemas/common-schemas/atone-common-schema';
import { allowEmpty, mandatoryStr, str } from '@schemas/common-schemas/schema-utils';

/**
 * atone翌月後払い決済サービスのサービス分類子の実際のチェック項目。
 *
 * これを持ってして、どのサービスのパラメータかをまず判別する。
 */
export const atoneSettlementServiceRawParameterClassifierSchema = z.object({
  service_type: z.literal('01'),
  modal_mode: z.literal('01').optional(),
});

/**
 * コールバック以外のServiceパラメータのバリデータ。
 *
 * postMessage経由で渡されたクライアントからの入力データは、たとえば数値型なら `1` だったり `"1"` だったり型的に不安定な入力を許容する仕様となっている。\
 * しかし、モーダル内部では型を厳密に扱うため、zodバリデータを通してチェックし、期待した型情報への正規化を行ってから利用することになっている。
 */
export const atoneSettlementServiceParameterValidator = z
  .object({
    pub_key: mandatoryStr,
    ...atoneSettlementServiceRawParameterClassifierSchema.shape,
    // 旧atone形式のコールバックを使うかどうか。コールバックのパラメータは新旧で異なるから、
    // コレでmodal -> client側からpostMessageするコールバックパラメータを変える。
    is_legacy: z.boolean().default(false),
    pre_token: allowEmpty(str),
    terminal_id: allowEmpty(str),
    payment: atonePaymentSchema,
    request_id: allowEmpty(str),
  })
  .passthrough();

export type AtoneSettlementServiceInputType = typeof atoneSettlementServiceParameterValidator._input;

/**
 * atone翌月後払い決済サービスのサービス分類子。
 *
 * これを持ってして、どのサービスのパラメータかをまず判別する。
 * チェック項目以外の全パラメータの型情報を付与も附与されている。
 *
 * クライアント -> ModalDriverに対する入力は、コレを利用してサービスの分類の正しさのみ検証する。
 */
export const atoneSettlementServiceParameterClassifierSchema =
  atoneSettlementServiceRawParameterClassifierSchema as unknown as typeof atoneSettlementServiceParameterValidator;
